// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.genericResponse.BaseResponse
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { BaseIssue } from "abweb/dto/generated/genericResponse/BaseIssue";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class BaseResponseBase {
  /** Do NOT invoke directly, instead use strongly typed createBaseResponseBase factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadg.BaseResponse";
  }
  initFromJson(json, deserializeContext) {
    this.initBaseResponse(TSOGUtils.decodeObject(json.issue, BaseIssue, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "issue")), json.payload != null ? json.payload : null);
  }
  initBaseResponse(issue, payload) {
    this._issue = issue;
    this._payload = payload;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    retVal["issue"] = TSOGUtils.toTSOGNativeObject(this._issue, serializeContext);
    if (this._payload != null) {
      retVal["payload"] = this._payload;
    }
    return retVal;
  }
  get issue() {
    return this._issue;
  }
  set issue(value) {
    this._issue = value;
  }
  get payload() {
    return this._payload;
  }
  set payload(value) {
    this._payload = value;
  }
}
//# sourceMappingURL=BaseResponseBase.js.map
